import React from 'react';
import I18n from 'i18n-js';
import { buttonClassName } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { CartClickInteraction } from '@reverbdotcom/commons/src/elog/mparticle_types';
import {
  core_apimessages_CheckoutPaymentMethod_Type as CheckoutPaymentMethodType,
} from '../schemas/rql';
import { useTrackCheckoutClickEvent } from './checkout/checkoutTracking';
import { PaymentMethodIcons } from './PaymentMethodIcons';
import { paymentMethodIcons } from '../lib/payment_method_icons';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';

interface Props {
  paymentMethodType: CheckoutPaymentMethodType;
  checkoutPath: string;
}

export default function CartStartCheckoutButton(props: Props) {
  const showIconRow = useExpEnabled(experiments.CHECKOUT_PAYMENT_METHOD_SELECTOR);

  const trackEvent = useTrackCheckoutClickEvent(
    {
      id: null,
      paymentMethod: {
        type: props.paymentMethodType,
      },
    },
  );

  return (
    <div className="d-flex fx-dir-col fx-gap-1 fx-align-center">
      <div className="mobile-width-100">
        <CoreLink
          to={props.checkoutPath}
          className={buttonClassName({ variant: 'primary', fullWidth: true })}
          onClick={() => trackEvent(CartClickInteraction.StartCheckout)}
        >
          {I18n.t('discovery.checkout.cart.startCheckout')}
          <span className="icon-r-arrow-right" />
        </CoreLink>
      </div>
      {showIconRow &&
        <PaymentMethodIcons
          icons={paymentMethodIcons(props.paymentMethodType)}
          variant="small"
        />
      }
    </div>
  );
}
